module.exports = __webpack_public_path__ + "static/contactusbg-a55ab0585cbc9d0bb4b6490833a6f969.svg";